import React, { ReactElement } from 'react'
import './popover-tooltip.scss'

import * as Popover from '@radix-ui/react-popover'
import { CrossIcon } from '../../icons/cross'

type PopoverTooltipProps = {
  showArrow?: boolean
  showCross?: boolean
  offset?: number
  content: ReactElement
  hiddenContent: ReactElement
}

const PopoverTooltip = ({
  showArrow,
  showCross,
  offset,
  content,
  hiddenContent,
}: PopoverTooltipProps) => (
  <Popover.Root>
    <Popover.Trigger asChild>
      <button className="IcBtnPopover" aria-label="Update dimensions">
        {content}
      </button>
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Content className="PopoverContent" sideOffset={offset || 5}>
        {hiddenContent}
        {showCross && (
          <Popover.Close className="PopoverClose" aria-label="Close">
            <CrossIcon className={'opacity-30'} />
          </Popover.Close>
        )}

        {showArrow && <Popover.Arrow className="PopoverArrow" />}
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
)

export default PopoverTooltip
